import ng from 'angular';
import angular from 'angular';
import { AgenciasService } from '../../../../Financas/Agencias/agencias.service';
import { StatusProcessoEnum } from '../../enums/statusprocesso.enum';
import { TipoRecebimentobolsaEnum } from '../../enums/tiporecebimentobolsa.enum';
import { TipoContaPixEnum } from '../../../../../shared/enums/TipoContaPixEnum';
import {
    contaBancoValida,
    getMensagemContaBanco,
    digitoVerificadorContaValido,
    getMensagemDigitoVerificador,
    TipoPagamentoEnum
} from '../../../../../utils/dados-bancarios';

export class MeurhAdmissoesestagiarioOutrasinformacoesFormController implements ng.IController {

    static $inject = ['$rootScope', '$scope', 'AgenciasService'];

    public entity: any;
    public form: angular.IFormController;
    public action: string;

    public tipoContaPixEnum = TipoContaPixEnum;

    public exibeAlertaConta: boolean = false;
    public focoInputConta: boolean = false;

    public exibeAlertaDigitoVerificador: boolean = false;
    public focoInputDigitoVerificador: boolean = false;

    public agenciaExistente = false;

    public tiposPagamentoChecaDv = [
        TipoPagamentoEnum.CONTA_CORRENTE,
        TipoPagamentoEnum.CONTA_POUPANCA,
        TipoPagamentoEnum.CONTA_SALARIO,
        TipoPagamentoEnum.PIX_AGENCIA_CONTA
    ];

    private statusProcessoEnum = StatusProcessoEnum;
    private tipoRecebimentobolsaEnum = TipoRecebimentobolsaEnum;

    constructor(
        private $rootScope: ng.IRootScopeService & { configuracoes: any },
        private $scope: angular.IScope,
        private AgenciasService: AgenciasService,
    ) {
        this.$scope.$on('agencias_list_finished', (_, args: { numero: string; digitoverificador: string; }[]) => {
            if (args && args.length) {
                const agencia = args.find(agencia => agencia.numero === this.entity.agencianumero);
                if (agencia) {
                    this.entity.agencianumerodv = agencia.digitoverificador;
                }
                this.agenciaExistente = !!agencia;
                return;
            }
            this.agenciaExistente = false;
        });
    }

    $onInit() {
        // se tipo de pagamento pode exibir alertas na conta e DV
        if (this.action === 'update' && this.tiposPagamentoChecaDv.includes(this.entity.tiporecebimentobolsa)) {
            this.validaContaPagamento();
            this.validaDigitoVerificadorConta();
        }
    }

    public alertaCampoInvalido(tipoAlerta: 'vazio' | 'pattern', campo: any): boolean {
        const condicoes = {
            'vazio': campo && campo.$error.required && (campo.$dirty || this.form.$submitted),
            'pattern': campo && campo.$error.pattern
        };

        return condicoes[tipoAlerta];
    }

    public desabilitaCampo(): boolean {
        return (
            this.action === 'show' ||
            this.entity.statusprocesso === this.statusProcessoEnum.ENVIADA ||
            this.entity.statusprocesso === this.statusProcessoEnum.EM_ACOMPANHAMENTO ||
            this.entity.$$__submitting
        );
    }

    public camposPagamento(tipo: 'banco' | 'pix'): boolean {
        const condicoes = {
            'banco': (
                (this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_CORRENTE ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_POUPANCA ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.CONTA_SALARIO) ||
                (this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_AGENCIA_CONTA && this.entity.tipocontapix)
            ),
            'pix': (
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CPF ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_EMAIL ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CELULAR ||
                this.entity.tiporecebimentobolsa === this.tipoRecebimentobolsaEnum.PIX_CHAVE_ALEATORIA
            )
        };

        return condicoes[tipo];
    }

    public getChavepixLabel(): string {
        const labels = {
            '128': 'CPF',
            '256': 'E-mail',
            '512': 'Celular',
            '1024': 'Chave aleatória',
        };

        return labels[this.entity.tiporecebimentobolsa];
    }

    // início - controle do formulário
    public aplicarSemDadosBancarios(): void {
        delete this.entity.banco;
        delete this.entity.agencia;
        delete this.entity.agencianumero;
        delete this.entity.numerocontasalario;
        delete this.entity.numerocontasalariodv;
        delete this.entity.agencianumerodv;
    }

    public preencheCamposRecebimento(): void {
        if (this.entity.tiporecebimentobolsa !== '') {
            this.entity.semdadosbancarios = false;
        }

        if (this.entity.tiporecebimentobolsa !== '64') {
            this.entity.tipocontapix = null;
        }

        if (!this.camposPagamento('banco')) {
            this.aplicarSemDadosBancarios();
        }

        switch (this.entity.tiporecebimentobolsa) {
            case this.tipoRecebimentobolsaEnum.PIX_CPF:
                this.entity.chavepix = this.entity.cpf;
                break;

            case this.tipoRecebimentobolsaEnum.PIX_EMAIL:
                this.entity.chavepix = this.entity.email;
                break;

            case this.tipoRecebimentobolsaEnum.PIX_CELULAR:
                if (this.entity.dddcel !== undefined || this.entity.celular !== undefined) {
                    this.entity.chavepix = this.entity.dddcel + this.entity.celular;
                }
                break;

            default:
                this.entity.chavepix = '';
                break;
        }
    }

    public desabilitarNenhumTipoPagamento(): boolean {
        return !!this.$rootScope.configuracoes.DESABILITAR_NENHUM_TIPO_PAGAMENTO_ADMISSOES;
    }

    public desabilitarNenhumaInstituicaoBancaria(): boolean {
        return !!this.$rootScope.configuracoes.DESABILITAR_NENHUMA_INSTITUICAO_BANCARIA_ADMISSOES;
    }

    public limpaDadosAgenciaConta() {
        this.entity.agencianumero = null;
        this.entity.agencianumerodv = null;
        this.entity.numerocontasalario = null;
        this.entity.numerocontasalariodv = null;
        this.agenciaExistente = false;
    }

    public limpaBanco() {
        this.entity.banco = null;
    }

    public verificaAgencia() {
        this.agenciaExistente = false;
        if (this.entity.agencianumero) {
            this.AgenciasService.constructors = { banco: this.entity.banco.banco };
            this.AgenciasService.search({ search: this.entity.agencianumero });
        }
    }

    public validaContaPagamento() {
        if (!this.entity.banco || !this.entity.tiporecebimentobolsa || !this.entity.numerocontasalario) {
            this.exibeAlertaConta = false;
            return;
        }

        this.exibeAlertaConta = !contaBancoValida(this.entity.banco, this.entity.tiporecebimentobolsa, this.entity.numerocontasalario, this.entity.tipocontapix) &&
            !this.form.numerocontasalario?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaConta() {
        if (!this.entity.banco || !this.entity.tiporecebimentobolsa || !this.entity.numerocontasalario) {
            return false;
        }

        return !this.focoInputConta && this.exibeAlertaConta;
    }

    public getMensagemAlertaConta(): string {
        return getMensagemContaBanco(this.entity.banco, this.entity.tiporecebimentobolsa, this.entity.numerocontasalario, this.entity.tipocontapix);
    }

    public validaDigitoVerificadorConta() {
        if (!this.entity.banco || !this.entity.tiporecebimentobolsa || !this.entity.numerocontasalariodv) {
            this.exibeAlertaDigitoVerificador = false;
            return;
        }

        this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.entity.banco, this.entity.tiporecebimentobolsa, this.entity.numerocontasalariodv, this.entity.tipocontapix) &&
            !this.form.numerocontasalariodv?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaDigitoVerificador() {
        if (!this.entity.banco || !this.entity.tiporecebimentobolsa || !this.entity.numerocontasalariodv) {
            return false;
        }

        return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
    }

    public getMensagemAlertaDigitoVerificador(): string {
        return getMensagemDigitoVerificador(this.entity.banco, this.entity.tiporecebimentobolsa, this.entity.numerocontasalariodv, this.entity.tipocontapix);
    }

    // fim - controle do formulário
}
